<form class="quote-wrapper needs-validation" novalidate [formGroup]="formFields"
  (ngSubmit)="onSubmit(content, referral)">
  <div class="container-fluid">
    <div class="row gx-4">

      <!-- LEFT CARD : COVER + PREMIUM -->
      <div class="col-md-6" *ngIf="staticData">
        <div class="quote-card">

          <!-- Select Cover -->
          <div class="mb-4">
            <label class="section-label">Select Cover <span class="text-danger">*</span></label>
            <mat-form-field appearance="outline" class="w-100">
              <mat-select formControlName="excess_protect_cover_id" required (selectionChange)="onCoverChange()">
                <mat-option *ngFor="let vw of excessProtectOptions.result" [value]="vw.id">
                  {{ vw.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Premium Section -->
          <h5 class="section-title">Premium</h5>

          <div *ngIf="quote_type !=3">
            <div class="premium-row">
              <span>Premium Excl IPT</span>
              <span>£{{ selectedPremium?.rate_excl_ipt || 0 | number:'1.2-2' }}</span>
            </div>

            <div class="premium-row">
              <span>Insurance Premium Tax (12%)</span>
              <span>
                £{{
                (selectedPremium?.rate_incl_ipt - selectedPremium?.rate_excl_ipt) || 0
                | number:'1.2-2'
                }}
              </span>
            </div>

            <div class="premium-row">
              <span>Peliwica Fee</span>
              <span>£0.00</span>
            </div>

            <hr />

            <div class="premium-row total">
              <span>Total Premium Including IPT</span>
              <span>£{{ selectedPremium?.rate_incl_ipt || 0 | number:'1.2-2' }}</span>
            </div>
          </div>

          <div *ngIf="quote_type ==3 && mtaFinancials">
            <div class="premium-row">
              <span>Premium Excl IPT</span>
              <span>£{{ mtaFinancials.adjustment_display_amount | number:'1.2-2' }}</span>
            </div>

            <div class="premium-row">
              <span>Insurance Premium Tax (12%)</span>
              <span>
                £{{ mtaFinancials.adjustment_display_ipt | number:'1.2-2' }}
              </span>
            </div>

            <div class="premium-row">
              <span>Peliwica Fee</span>
              <span>£0.00</span>
            </div>

            <hr />

            <div class="premium-row total">
              <span>Total Premium Including IPT</span>
              <span>£{{ mtaFinancials.adjustment_display_total | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT CARD : QUOTE SUMMARY -->
      <div class="col-md-6">
        <div class="quote-card">

          <h5 class="section-title">Quote Summary</h5>

          <div class="summary-row">
            <span>Product</span>
            <strong>Peliwica Excess Protect</strong>
          </div>

          <div class="summary-row">
            <span>Quote Reference</span>
            <strong>{{ reference }}</strong>
          </div>

          <div class="summary-row">
            <span>Cover Dates</span>
            <strong>{{ coverPeriod }}</strong>
          </div>

          <div class="mt-4 d-flex gap-2 flex-wrap ml-2" *ngIf="documents?.length">

            <button *ngFor="let doc of documents" type="button" class="btn btn-success btn-sm px-3 ml-2"
              (click)="downloadDocument('download', doc)">
              {{ getDisplayTitle(doc.title) }}
            </button>
            <!-- <a
              [href]="policyWordingDocUrl"
              target="_blank"
              class="btn btn-success btn-sm px-3"
            >
              Policy Wording
            </a>

            <a
              [href]="breakdownWordingDocUrl"
              target="_blank"
              class="btn btn-success btn-sm px-3 ml-2"
            >
              Excess Protect Wording
            </a>

            <a
              [href]="ipidWordingDocUrl"
              target="_blank"
              class="btn btn-success btn-sm px-3 ml-2"
            >
              IPID
            </a> -->
          </div>

        </div>
      </div>

    </div>

    <!-- ACTION BAR -->
    <div class="row mt-4">
      <div class="col-md-12 text-right">
        <button type="button" class="btn btn-success back-btn" (click)="goBack()">
          ← Back
        </button>
        <button type="submit" class="btn btn-success px-4" (click)="setReferAndExit(false)">
          Save and View Quote
        </button>
      </div>
    </div>

  </div>
</form>

<ng-template #content let-modal>
  <div class="modal-body">
    <div class="helptext" [innerHTML]="helptext"></div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
  </div>
</ng-template>
<ng-template #referral let-modal>
  <div class="modal-body">
    <div class="helptext">Clicking save will send your quote to the underwriter, the quote will then be locked for
      editing until the underwriter decision has been made. If you need to edit your quote please do so before
      clicking save.</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dark" (click)="modal.close()">Exit</button>
    <button type="button" class="btn btn-success" (click)="saveQuote(content)">Save</button>
  </div>
</ng-template>